import React, { useEffect, useState } from 'react';
import { mediaFilter } from '../../../utils/image';

interface ImageDropzoneProps {
  image: File | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  title: string;
  img?: string;
}

const ImageDropzone: React.FC<ImageDropzoneProps> = ({ image, onChange, title, img }) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    if(img){
        setPreviewUrl(mediaFilter({path: img}))
    }
    if (image) {
      const objectUrl = URL.createObjectURL(image);
      setPreviewUrl(objectUrl);

      return () => URL.revokeObjectURL(objectUrl); 
    } else {
      setPreviewUrl(null);
    }
  }, [image]);

  useEffect(() => {
    if(img){
        setPreviewUrl(mediaFilter({path: img}))
    }
  }, [img]);

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];
    if (!file || !file.type.startsWith('image/')) return;

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    const fakeInput = {
      target: {
        files: dataTransfer.files,
      },
    } as React.ChangeEvent<HTMLInputElement>;

    onChange(fakeInput);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return (
    <>
    <div>
        {title}
    </div>
        <div
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        className=" border border-dashed border-gray-400 rounded p-4 text-center cursor-pointer w-fit"
        >
        <input
            type="file"
            accept="image/*"
            onChange={onChange}
            className="hidden"
            id="image-upload"
        />
        <label htmlFor="image-upload" className="cursor-pointer block  ">
            {previewUrl ? (
                <>
                    <img src={previewUrl} alt="Preview" className="max-h-[100px] max-w-[100px] w-[100px] h-[100px] object-cover mx-auto rounded" />
                    <p className='text-sm text-center'>Pulsa para cambiar</p>
                </>
            ) : (
            <p className='text-center bg-gray-200 p-4 rounded w-[150px]'>Arrastra una imagen aquí o haz clic para seleccionar</p>
            )}
        </label>
        </div>
    </>
    
  );
};

export default ImageDropzone;
